module.exports = "app-servico-plano-table {\n    width: 100%;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/manutencoes/servicos/servico-planos/servico-plano-form-list/servico-plano-form-list.component.css
 ** module id = 993
 ** module chunks = 0
 **/